import { defineMessages } from '@jutro/locale';

export default defineMessages({
    YearBuilt: {
        id: 'ml-gateway.views.policy-summary.construction.Year Built',
        defaultMessage: 'Year Built'
    },
    ConstructionType: {
        id: 'ml-gateway.views.policy-summary.construction.Construction Type',
        defaultMessage: 'Construction Type'
    },
    NumFamilies: {
        id: 'ml-gateway.views.policy-summary.construction.NumFamilies',
        defaultMessage: 'Number of Families'
    },
    HouseAge: {
        id: 'ml-gateway.views.policy-summary.construction.HouseAge',
        defaultMessage: 'House Age'
    },
    ApproxSquareFootage: {
        id: 'ml-gateway.views.policy-summary.construction.ApproxSquareFootage',
        defaultMessage: 'Square Feet'
    },
    NumStories: {
        id: 'ml-gateway.views.policy-summary.construction.NumStories',
        defaultMessage: 'Number of Stories'
    },
    NumFullBathrooms: {
        id: 'ml-gateway.views.policy-summary.construction.NumFullBathrooms',
        defaultMessage: 'Number of Full Bathrooms'
    },
    NumThreeQuarterBathrooms: {
        id: 'ml-gateway.views.policy-summary.construction.NumThreeQuarterBathrooms',
        defaultMessage: 'Number of 3/4 Bathrooms'
    },
    NumHalfBathrooms: {
        id: 'ml-gateway.views.policy-summary.construction.NumHalfBathrooms',
        defaultMessage: 'Number of 1/2 Bathrooms'
    },
    NumBedrooms: {
        id: 'ml-gateway.views.policy-summary.construction.NumBedrooms',
        defaultMessage: 'Number of Bedrooms'
    },
    ExteriorWallFinish: {
        id: 'ml-gateway.views.policy-summary.construction.ExteriorWallFinish',
        defaultMessage: 'Exterior Wall Finish'
    },
    AttachedGarages: {
        id: 'ml-gateway.views.policy-summary.construction.Attached Garages',
        defaultMessage: 'Attached Garages'
    },
    AttachedGaragesNumCars: {
        id: 'ml-gateway.views.policy-summary.construction.Attached Garages - Number of Cars',
        defaultMessage: 'Attached Garages - Number of Cars'
    },
    DetachedGarages: {
        id: 'ml-gateway.views.policy-summary.construction.Detached Garages',
        defaultMessage: 'Detached Garages'
    },
    DetachedGaragesNumCars: {
        id: 'ml-gateway.views.policy-summary.construction.Detached Garages - Number of Cars',
        defaultMessage: 'Detached Garages - Number of Cars'
    },
    DashDash: {
        id: 'ml-gateway.views.policy-summary.construction.Dash Dash',
        defaultMessage: '- -'
    },
    DwellingCharacteristics: {
        id: 'ml-gateway.views.policy-summary.construction.Dwelling Characteristics',
        defaultMessage: 'Dwelling Characteristics'
    },
    Foundation: {
        id: 'ml-gateway.views.policy-summary.construction.Foundation',
        defaultMessage: 'Foundation'
    },
    FoundationType: {
        id: 'ml-gateway.views.policy-summary.construction.Foundation Type',
        defaultMessage: 'Foundation Type'
    },
    PercentageBasementFinished: {
        id: 'ml-gateway.views.policy-summary.construction.Percentage Basement Finished',
        defaultMessage: 'Percentage Basement Finished'
    },
    WalkoutBasement: {
        id: 'ml-gateway.views.policy-summary.construction.Walkout Basement',
        defaultMessage: 'Walkout Basement'
    },
    FoundationMaterial: {
        id: 'ml-gateway.views.policy-summary.construction.Foundation Material',
        defaultMessage: 'Foundation Material'
    },
    Roof: {
        id: 'ml-gateway.views.policy-summary.construction.Roof',
        defaultMessage: 'Roof'
    },
    RoofCoveringType: {
        id: 'ml-gateway.views.policy-summary.construction.Roof Covering Type',
        defaultMessage: 'Roof Covering Type'
    },
    RoofShape: {
        id: 'ml-gateway.views.policy-summary.construction.Roof Shape',
        defaultMessage: 'Roof Shape'
    },
    Heating: {
        id: 'ml-gateway.views.policy-summary.construction.Heating',
        defaultMessage: 'Heating'
    },
    PrimaryHeatingSystem: {
        id: 'ml-gateway.views.policy-summary.construction.Primary Heating System',
        defaultMessage: 'Primary Heating System'
    },
    SecondaryHeatingSystem: {
        id: 'ml-gateway.views.policy-summary.construction.Secondary Heating System',
        defaultMessage: 'Secondary Heating System'
    },
    Fireplaces: {
        id: 'ml-gateway.views.policy-summary.construction.Fireplaces',
        defaultMessage: 'Fireplaces'
    },
    FireplaceType: {
        id: 'ml-gateway.views.policy-summary.construction.Fireplace Type',
        defaultMessage: 'Type of Fireplace'
    },
    ValuationID: {
        id: 'ml-gateway.views.policy-summary.construction.Valuation ID',
        defaultMessage: 'Valuation ID'
    },
    Version: {
        id: 'ml-gateway.views.policy-summary.construction.Version',
        defaultMessage: 'Version'
    },
    VersionDate: {
        id: 'ml-gateway.views.policy-summary.construction.Version Date',
        defaultMessage: 'Version Date'
    },
    EstimatedReplacementCost: {
        id: 'ml.agent.views.ml-policy-summary.Construction.EstimatedReplacementCost',
        defaultMessage: 'Estimated Replacement Cost'
    },
    Construction: {
        id: 'ml.agent.views.ml-policy-summary.Construction.Construction',
        defaultMessage: 'Construction'
    },
    Yes: {
        id: 'ml.agent.views.ml-policy-summary.Construction.Yes',
        defaultMessage: 'Yes'
    },
    No: {
        id: 'ml.agent.views.ml-policy-summary.Construction.No',
        defaultMessage: 'No'
    },
    inflationOrRCApplied: {
        id: 'ml.agent.views.ml-policy-summary.ConstructionInflation or Replacement Cost Applied.',
        defaultMessage: 'Inflation or Replacement Cost Applied'
    },
    close: {
        id: 'ml.agent.views.ml-policy-summary.Close',
        defaultMessage: 'Close'
    },
    aerialImagery: {
        id: 'ml.agent.views.ml-policy-summary.Aerial Imagery',
        defaultMessage: 'Aerial Imagery'
    },
    imageryUnavailable: {
        id: 'ml.agent.views.ml-policy-summary.Imagery is not available for this location',
        defaultMessage: 'Imagery is not available for this location'
    },
    loadingImagery: {
        id: 'ml.agent.views.ml-policy-summary.Loading Aerial Imagery',
        defaultMessage: 'Loading Aerial Imagery'
    },
    downloadReplacementCostError: {
        id: 'ml.agent.views.ml-policy-summary.Construction.ReplacementCostUnavailable',
        defaultMessage: 'Replacement cost summary is not available for this policy'
    },
    loadingReplacementCost: {
        id: 'ml.agent.views.ml-policy-summary.Construction.LoadingReplacementCost',
        defaultMessage: 'Loading Replacement Cost Summary'
    },
    viewReplacementCostSummary: {
        id: 'ml.agent.views.ml-policy-summary.Construction.VIEW REPLACEMENT COST SUMMARY',
        defaultMessage: 'VIEW REPLACEMENT COST SUMMARY'
    },
    documentError: {
        id: 'ml.agent.views.ml-policy-summary.Construction.Error',
        defaultMessage: 'Error'
    },
    downloadDocError: {
        id: 'ml.agent.views.ml-policy-summary.Construction.We were unable to download your document, please try again.',
        defaultMessage: 'We were unable to download your document, please try again.'
    }
});
